import { render, staticRenderFns } from "./Treeview.vue?vue&type=template&id=72c470ae"
import script from "./Treeview.vue?vue&type=script&lang=js"
export * from "./Treeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports